module.exports = __webpack_public_path__ + "static/media/gaivotas.0203b5f8.mp3";